import { IconFlower } from "@tine/designsystem-icons/sharp";
import { Button, Modal } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import authStore from "../../../stores/auth/authStore";
import promotionStore from "../../../stores/promotionStore";
import uiStore from "../../../stores/uiStore";
import AdventCalendarReminderForm, { classNameChristmasButton } from "./AdventCalendarReminderForm";
import { type AdventCalendarCampaign, AFTER_OPENING_BONUS, getAdventCalendarTickets } from "./adventCalendarUtils";

type AdventCalendarReminderSignupModalProps = { campaign: AdventCalendarCampaign };

const AdventCalendarReminderSignupModal = observer(({ campaign }: AdventCalendarReminderSignupModalProps) => {
   const isOpen = uiStore.showAdventCalendarReminderSignupModal && authStore.isLoggedIn();
   const isSignedUp = promotionStore.isSignedUpTo(campaign.reminderSignUpCode);
   const { bonusTickets } = getAdventCalendarTickets(campaign, promotionStore.signUps.data);

   return (
      <Modal
         isOpen={isOpen}
         onClose={uiStore.toggleAdventCalendarReminderSignupModal}
         className={{
            header: "pb-0 flex justify-end",
            content: cn("[&>div]:pt-0", classNameChristmasButton),
            container: cn("bg-christmas text-ink-brand-inverted text-center [&_label]:text-ink-brand-inverted bg-christmas"),
            closeButton: "text-ink-brand-inverted hover:bg-christmasButtonHover"
         }}
      >
         <div className={"flex flex-col gap-4 items-center pb-4"}>
            <div className={"flex justify-center items-center"}>
               <IconFlower height={32} width={32} />
               <IconFlower height={64} width={64} />
               <IconFlower height={32} width={32} />
            </div>
            <h2 className="text-3xl">{!isSignedUp ? `Få ${AFTER_OPENING_BONUS} ekstra lodd` : "Din bedrift er påmeldt!"}</h2>
            {!isSignedUp ? (
               <p>
                  Bli med i trekningen av flotte premier. Samle lodd ved å delta i kalenderlukene – jo flere lodd, desto større
                  vinnersjanse!
               </p>
            ) : (
               <>
                  <p>Dere har samlet {bonusTickets} lodd til hovedtrekningen.</p>
                  <p>
                     Du kan åpne en ny luke hver dag for å samle lodd og øke din vinnersjanse. Du vil motta påminnelse på e-post.
                  </p>
                  <p>Vinnerne kontaktes etter trekningen. Se kalenderens vilkår for mer informasjon.</p>
               </>
            )}
            {!isSignedUp && <AdventCalendarReminderForm campaign={campaign} />}
            <Button
               size="compact"
               onClick={uiStore.toggleAdventCalendarReminderSignupModal}
               variant="tertiary"
               className={cn({ "!bg-transparent !border-transparent": !isSignedUp })}
            >
               Lukk
            </Button>
         </div>
      </Modal>
   );
});

export default AdventCalendarReminderSignupModal;
